export { Heading, Subheadline, Paragraph, ButtonText, SidebarText, Caption } from './Typography';
